import { useLocation } from "react-router";

export default function useIsActive() {
  const location = useLocation();

  return (href: string, altPaths: string[] = []) => {
    if (href === "/") {
      return href === location.pathname;
    }

    return (
      location.pathname.startsWith(href) ||
      altPaths.some((path) => location.pathname.startsWith(path))
    );
  };
}
